// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1X_tY","inputWrap":"Table_inputWrap__1mlFt","col":"Table_col__1D2wR","bmiTooltip":"Table_bmiTooltip__1BWlD"};